// This should be the same as Microsoft.Online.BOX.Util.HostApp
export var SupportedHostingApps;
(function (SupportedHostingApps) {
    SupportedHostingApps["M365AdminPortal"] = "M365AdminPortal";
    SupportedHostingApps["SPOAdminPortal"] = "SPOAdminPortal";
    // This is not the same as SPOAdminPortal - this is for HVCs that will be used in SharePoint Sites.
    SupportedHostingApps["SPOPortal"] = "SPOPortal";
    SupportedHostingApps["EXOAdminPortal"] = "EXOAdminPortal";
    SupportedHostingApps["TeamsAdminPortal"] = "TeamsAdminPortal";
    SupportedHostingApps["SecurityPortal"] = "SecurityPortal";
    SupportedHostingApps["CompliancePortal"] = "CompliancePortal";
    SupportedHostingApps["M365SCCPortal"] = "M365SCCPortal";
    SupportedHostingApps["SupportCentral"] = "SupportCentral";
    SupportedHostingApps["IbizaMTMPortal"] = "IbizaMTMPortal";
    SupportedHostingApps["CloudCostManagementPortal"] = "CloudCostManagementPortal";
    SupportedHostingApps["Rave"] = "Rave";
    SupportedHostingApps["DynamicsPortal"] = "DynamicsPortal";
    SupportedHostingApps["TeamsApp"] = "TeamsApp";
    SupportedHostingApps["M365DefenderSMB"] = "M365DefenderSMB";
    // Windows 365 Portal is also called as Cloud PC Portal
    SupportedHostingApps["Windows365Portal"] = "Windows365Portal";
    SupportedHostingApps["PPACAdminPortal"] = "PPACAdminPortal";
    SupportedHostingApps["VivaGoals"] = "VivaGoals";
    SupportedHostingApps["VivaPulse"] = "VivaPulse";
    SupportedHostingApps["FireSurveysHost"] = "FireSurveysHost";
    SupportedHostingApps["AEM"] = "AEM";
    SupportedHostingApps["ExcelPythonAddon"] = "ExcelPythonAddon";
    SupportedHostingApps["AdminAppMetaOSTeams"] = "AdminAppMetaOSTeams";
    SupportedHostingApps["AdminAppMetaOSOffice"] = "AdminAppMetaOSOffice";
    SupportedHostingApps["Project"] = "Project";
    SupportedHostingApps["Planner"] = "Planner";
    SupportedHostingApps["Visio"] = "Visio";
    SupportedHostingApps["Clipchamp"] = "Clipchamp";
})(SupportedHostingApps || (SupportedHostingApps = {}));
// NOTE: those names should be globally unique among all admin centers.
export var RuntimeDataSources;
(function (RuntimeDataSources) {
    RuntimeDataSources["Static"] = "centro.runtime.static";
})(RuntimeDataSources || (RuntimeDataSources = {}));
